import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6054e656"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "team-result-intermiadiate" }
const _hoisted_2 = {
  key: 0,
  class: "row justify-content-center p-5"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 1,
  class: "p-5 pb-4"
}
const _hoisted_5 = {
  key: 0,
  class: "d-flex my-3"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-list-ul",
  style: {"margin-top":"0.18em"}
}, null, -1))
const _hoisted_7 = { class: "ms-4 col" }
const _hoisted_8 = { class: "fs-7 fw-bold text-uppercase" }
const _hoisted_9 = { class: "row d-flex col my-3" }
const _hoisted_10 = {
  key: 0,
  class: "col-12 col-md-6 d-flex"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-list-ul",
  style: {"margin-top":"0.18em"}
}, null, -1))
const _hoisted_12 = { class: "ms-4" }
const _hoisted_13 = { class: "fs-7 fw-bold text-uppercase" }
const _hoisted_14 = {
  key: 1,
  class: "col-12 col-md-6 d-flex"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-person-lines-fill",
  style: {"margin-top":"0.15em"}
}, null, -1))
const _hoisted_16 = { class: "ms-4" }
const _hoisted_17 = { class: "fs-7 text-uppercase" }
const _hoisted_18 = {
  key: 1,
  class: "col d-flex my-3"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi-people" }, null, -1))
const _hoisted_20 = { class: "ms-4" }
const _hoisted_21 = { class: "fs-7 fw-bold text-uppercase" }
const _hoisted_22 = {
  key: 2,
  class: "col d-flex my-3"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi-paperclip" }, null, -1))
const _hoisted_24 = { class: "ms-4" }
const _hoisted_25 = { class: "fs-7 fw-bold text-uppercase" }
const _hoisted_26 = ["src"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi-file-pdf-fill" }, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 3,
  class: "col my-3"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-stickies" }, null, -1))
const _hoisted_31 = { class: "fs-7 ms-4 fw-bold text-uppercase" }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = {
  key: 2,
  class: "container justify-content-center p-7"
}
const _hoisted_34 = { class: "lead text-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_MrUiKitBlob = _resolveComponent("MrUiKitBlob")!
  const _component_IntermiadiateBlock = _resolveComponent("IntermiadiateBlock")!
  const _component_EntityBlock = _resolveComponent("EntityBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Spinner)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.showBlob)
            ? (_openBlock(), _createBlock(_component_MrUiKitBlob, {
                key: 0,
                files: _ctx.blobFiles,
                onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showBlob = false))
              }, null, 8, ["files"]))
            : _createCommentVNode("", true),
          (_ctx.intermiadiate != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_ctx.intermiadiate.intermiadiates.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _hoisted_6,
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.t("result.intermiadiate")), 1),
                        _createVNode(_component_IntermiadiateBlock, {
                          items: _ctx.intermiadiate.intermiadiates
                        }, null, 8, ["items"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                  (_ctx.intermiadiate.organizations.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _hoisted_11,
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.t("common.organizations")), 1),
                          _createVNode(_component_EntityBlock, {
                            items: _ctx.intermiadiate.organizations
                          }, null, 8, ["items"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.intermiadiate.trainers.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.t("common.trainers")), 1),
                          _createVNode(_component_EntityBlock, {
                            entity: _ctx.trainerEntity,
                            items: _ctx.intermiadiate.trainers
                          }, null, 8, ["entity", "items"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.intermiadiate.athletes.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.t("common.athletes")), 1),
                        _createVNode(_component_EntityBlock, {
                          entity: _ctx.athleteEntity,
                          items: _ctx.intermiadiate.athletes
                        }, null, 8, ["entity", "items"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.intermiadiate.attachments.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.t("result.attachments")), 1),
                        _createElementVNode("div", {
                          class: "d-flex mt-3",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showBlob = true))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.intermiadiate.attachments, (a, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: 'attachment-' + index,
                              class: "pointer-sub"
                            }, [
                              (!_ctx.isPdf(a.url))
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    class: _normalizeClass(["avatar-initials", index !== 0 && 'ms-3']),
                                    style: {"width":"60px","height":"60px"},
                                    src: a.url
                                  }, null, 10, _hoisted_26))
                                : (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    class: _normalizeClass([index !== 0 && 'ms-3', "icon icon-soft-danger"]),
                                    style: {"width":"60px","height":"60px"}
                                  }, _hoisted_28, 2))
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.generalNotes)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _hoisted_30,
                      _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.t("common.notes")), 1),
                      _createElementVNode("div", {
                        class: "ms-6 mt-4",
                        innerHTML: _ctx.generalNotes
                      }, null, 8, _hoisted_32)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.t("common.noDetails")), 1)
              ]))
        ]))
  ]))
}